<div class="app-footer">
    <div class="footer-bottom">
        <div class="text-right">
            <p class="m-0">&copy; {{currentYear}} <a href="https://engaje.com.au/" target="_blank">Engaje</a> All rights
                reserved</p>
        </div>
    </div>
</div>